import { MapLayerGroupControl } from '@/views/map/MapLayerManager/MapLayerGroupControl/MapLayerGroupControl';
import { useAppSelector, useAppDispatch } from '@/app/hooks';
import { update as updateMapLayerConfig } from '@/features/mapLayerSlice';
import { LayerType } from '@/views/map/layers/types';
import { useDatasets } from '@/hooks/useDatasets';
import { CriticalTreesLayerOption } from '@/views/map/MapLayerManager/MapLayerGroupControl/MapLayerOption/CriticalTreesLayerOption';
import { hasLayer } from './utils';

export const TreeCrownsControl = () => {
  const dispatch = useAppDispatch();
  const layerConfig = useAppSelector((s) => s.mapLayer);
  const { datasets } = useDatasets();

  const selected = LayerType[LayerType.critical_trees];
  const isActive = layerConfig[LayerType.critical_trees].visible;

  const updateState = (isVisible: (z: string) => boolean) => {
    dispatch(
      updateMapLayerConfig({
        [LayerType.critical_trees]: { visible: isVisible('critical_trees') },
      })
    );
  };

  const setTreeCrownViz = (v: boolean) =>
    updateState((selectedType: string) => v && selected === selectedType);
  const setOption = (v: string) =>
    updateState((selectedType: string) => isActive && v === selectedType);

  return (
    <MapLayerGroupControl
      title="Tree crowns"
      description="The detected tree crown outlines"
      onVisibilityChange={setTreeCrownViz}
      isGroupVisible={isActive}
      data-testid="tree-crowns-control"
    >
      {hasLayer(datasets, LayerType.critical_trees) && (
        <CriticalTreesLayerOption selected={selected} onChange={setOption} />
      )}
    </MapLayerGroupControl>
  );
};
